var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 283.198,
    height: 191.719,
    viewBox: "0 0 283.198 191.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(1 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "a",
    transform: "translate(11.942 30)",
    fill: "#fff",
    fontSize: 28,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.401,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(11.927 182.719)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.356,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    id: "w",
    transform: "translate(12 106.859)",
    fill: "#fff",
    fontSize: 28,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.489,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "S-2",
    "data-name": "S",
    transform: "translate(81.889 29)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.356,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    id: "e",
    transform: "translate(81.889 182.719)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.449,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "h",
    transform: "translate(81.933 107.859)",
    fill: "#fff",
    fontSize: 29,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.429,
    y: 0
  }, "H")), /*#__PURE__*/React.createElement("text", {
    id: "K",
    transform: "translate(143.967 27)",
    fill: "#fff",
    fontSize: 25,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.263,
    y: 0
  }, "K")), /*#__PURE__*/React.createElement("text", {
    id: "r",
    transform: "translate(144.967 183.719)",
    fill: "#fff",
    fontSize: 28,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.319,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    id: "y",
    transform: "translate(143.953 102.859)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.334,
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "M",
    transform: "translate(217.944 30)",
    fill: "#fff",
    fontSize: 28,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.079,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "v",
    transform: "translate(215.9 180.719)",
    fill: "#fff",
    fontSize: 25,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.214,
    y: 0
  }, "V")), /*#__PURE__*/React.createElement("text", {
    id: "i",
    transform: "translate(216.812 96.859)",
    fill: "#fff",
    fontSize: 19,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.394,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "E-2",
    "data-name": "E",
    transform: "translate(272.066 29)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.449,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "E-3",
    "data-name": "E",
    transform: "translate(272.066 181.733)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "OpenSans-Light, Open Sans",
    fontWeight: 300,
    letterSpacing: "0.42em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.449,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(253.796 85.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    "data-name": "Path 4012",
    d: "M25.056,312.924l-4.85,2.491a2.278,2.278,0,0,0-1.632-.688H15.243a1.054,1.054,0,0,1-.226-.014,1.88,1.88,0,0,1-.176-.156l-.031-.029c-2.7-2.543-4.983-2.382-7.581-1.358a1.719,1.719,0,0,1-.827.181H5.648a1.646,1.646,0,0,0-1.556-1.114H1.644A1.645,1.645,0,0,0,0,313.883v6.428a1.645,1.645,0,0,0,1.644,1.644H4.093a1.646,1.646,0,0,0,1.556-1.115H7.014a.629.629,0,0,1,.254.038l.2.055,6.338,1.7c.28.076.536.15.784.222a8,8,0,0,0,2.21.434,4.856,4.856,0,0,0,2.76-.995l.016-.011,7.815-5.564a2.226,2.226,0,0,0-2.333-3.79ZM4.474,320.31a.382.382,0,0,1-.381.381H1.644a.387.387,0,0,1-.381-.381v-6.428a.387.387,0,0,1,.381-.381H4.093a.382.382,0,0,1,.381.381Zm22.183-4.623-7.806,5.558c-1.6,1.064-2.276.867-3.911.393-.253-.074-.516-.15-.808-.229l-6.339-1.7-.182-.05a1.706,1.706,0,0,0-.6-.086H5.736v-4.961h.672l.048,0a2.877,2.877,0,0,0,1.236-.268c2.269-.894,4.019-1,6.252,1.1l.03.029a1.51,1.51,0,0,0,1.268.513h3.331a1.022,1.022,0,0,1,.886.514l0,0c.005.01.011.019.016.028a1.011,1.011,0,0,1,.118.474,1.023,1.023,0,0,1-1.022,1.022h-5.4a.631.631,0,0,0,0,1.262h5.4a2.283,2.283,0,0,0,2.232-2.767l4.827-2.479a.968.968,0,1,1,1.024,1.64Z",
    transform: "translate(0 -298.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1077035",
    "data-name": 1077035,
    d: "M7.09,11.373a.886.886,0,0,1-.548-.186c-.573-.452-1.125-.876-1.612-1.25l0,0A28.963,28.963,0,0,1,1.407,6.956,4.516,4.516,0,0,1,0,3.842,3.777,3.777,0,0,1,1.125,1.113,4.017,4.017,0,0,1,3.961,0,3.822,3.822,0,0,1,6.19.693a4.335,4.335,0,0,1,.9.848,4.335,4.335,0,0,1,.9-.848A3.822,3.822,0,0,1,10.219,0a4.017,4.017,0,0,1,2.836,1.113A3.777,3.777,0,0,1,14.18,3.842a4.515,4.515,0,0,1-1.406,3.114,28.959,28.959,0,0,1-3.52,2.979c-.488.375-1.041.8-1.615,1.253a.887.887,0,0,1-.548.185ZM3.961.749a3.152,3.152,0,0,0-2.226.872,3.07,3.07,0,0,0-.9,2.221A3.8,3.8,0,0,0,2.046,6.478a28.51,28.51,0,0,0,3.42,2.887l0,0c.489.376,1.044.8,1.621,1.257.581-.456,1.136-.882,1.626-1.259a28.517,28.517,0,0,0,3.42-2.887A3.805,3.805,0,0,0,13.35,3.842a3.07,3.07,0,0,0-.9-2.221A3.152,3.152,0,0,0,10.219.749a2.952,2.952,0,0,0-1.72.537,3.765,3.765,0,0,0-.959,1,.555.555,0,0,1-.9,0,3.761,3.761,0,0,0-.959-1A2.952,2.952,0,0,0,3.961.749Zm0,0",
    transform: "translate(11.399 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeImage);
export default __webpack_public_path__ + "static/media/orangeImage.fe11764980bd8f2f1947948da29e5451.svg";
export { ForwardRef as ReactComponent };